import { noLocation } from '@src/components/Mobile/Providers/Location/Location'
import { Geolocation } from '@capacitor/geolocation'

export const useGetCurrentLocationFunc = () => {
  return async () => {
    let locationData = noLocation

    const currentPosition = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
    })
    locationData = {
      latitude: currentPosition?.coords.latitude,
      longitude: currentPosition?.coords.longitude,
      accuracy: currentPosition?.coords.accuracy,
    }

    return locationData
  }
}
